import { useOrganizationAccess } from "@/hooks/useOrganizationAccess";

export const OrganizationAccessSync = () => {
  useOrganizationAccess();
  return null;
};
